import { useState, useCallback } from 'react';
import useAlertStore from '@/stores/alertStore';
import { noteGoApiFetch } from '@/services/noteGoApi/noteGoApiFetcher';
import { errorReporter } from '@/services/errorReportingService';

export const useSendFormatToZapier = () => {
  const showAlert = useAlertStore((state) => state.showAlert);
  const [isSending, setIsSending] = useState(false);

  const sendFormatToZapier = useCallback(
    async (noteId: string, formatId: string) => {
      if (!noteId || !formatId) return;
      setIsSending(true);
      try {
        const response = await noteGoApiFetch({
          url: '/zapier/send-format',
          method: 'POST',
          body: { note_id: noteId, format_id: formatId },
        });
        showAlert('Format sent to Zapier successfully!', 'success');
        return response;
      } catch (error) {
        errorReporter.expected('Failed to send format to Zapier', error, {
          feature: 'zapier',
          operation: 'sendFormatToZapier',
          noteId,
          formatId,
        });
        showAlert('Failed to send format to Zapier. Check your webhook URL in Beta settings.', 'error');
      } finally {
        setIsSending(false);
      }
    },
    [showAlert],
  );

  return { sendFormatToZapier, isSending };
};
